module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatments-7up",
    style: ({
      backgroundImage: 'url(' + _vm.props.bg_img + ')'
    }),
    attrs: {
      "id": "seven-up"
    }
  }, [_c('div', {
    staticClass: "custom-treatments-7up__container"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatments-7up__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.seven_up_logo) ? _c('img', {
    staticClass: "custom-treatments-7up__uplogo",
    attrs: {
      "src": _vm.props.seven_up_logo
    }
  }) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "custom-treatments-7up__row"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__left"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__icon-outer"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__icon-inner"
  }, [_c('Icon', {
    staticClass: "custom-treatments-7up__icon",
    attrs: {
      "name": "faces"
    }
  })], 1)]), _c('div', {
    staticClass: "custom-treatments-7up__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.top.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-treatments-7up__top-text hello",
    domProps: {
      "innerHTML": _vm._s(_vm.props.top.text)
    }
  })]), _c('div', {
    staticClass: "custom-treatments-7up__right",
    style: ({
      backgroundImage: 'url(' + _vm.props.top.img + ')'
    })
  })]), _c('div', {
    staticClass: "custom-treatments-7up__row"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__left"
  }, [_c('div', {
    staticClass: "custom-treatments-7up__header",
    domProps: {
      "innerHTML": _vm._s(_vm.props.bottom.header)
    }
  }), _c('div', {
    staticClass: "custom-treatments-7up__bottom-text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.bottom.text)
    }
  })]), _c('div', {
    staticClass: "custom-treatments-7up__right",
    style: ({
      backgroundImage: 'url(' + _vm.props.bottom.img + ')'
    })
  })]), _c('div', {
    staticClass: "custom-treatments-7up__form"
  }, [_c('Form')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatments-7up_button"
  }, [_c('div', {
    staticClass: "custom-treatments-invisalign__read-more"
  }, [_c('a', {
    attrs: {
      "href": "tel:1-585-742-1050"
    }
  }, [_vm._v("Call Us")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f496a0e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-treatments-7up/custom-treatments-7up.pug
// module id = 736
// module chunks = 1